module.exports = __webpack_public_path__ + "static/1283900775.2ec8f2c3.jpg";